import updateBookingMeetingType from '../services/updateBookingMeetingType';
import setIsPerformingServiceUpdate from '../actions/setIsPerformingServiceUpdate';
import enableDisableMeetingTypeAction from '../actions/enableDisableMeetingTypeAction';
import store from '../store/Store';
import { trace } from 'owa-trace';
/**
 * Triggers a service call to enable/disable a booking service.
 */
export default function enableDisableMeetingType(
    meetingTypeId: string | undefined,
    shouldBeEnabled: boolean
): Promise<boolean> {
    if (meetingTypeId) {
        try {
            setIsPerformingServiceUpdate(true);
            if (store.meetingTypes) {
                const meetingType = store.meetingTypes.get(meetingTypeId);
                enableDisableMeetingTypeAction(meetingTypeId, shouldBeEnabled);
                if (meetingType) {
                    //TODO: error handling - result.UpdatedBookingServiceItemId.Id !== service.ItemId.Id
                    updateBookingMeetingType(meetingType).then(() => {
                        setIsPerformingServiceUpdate(false);
                        return Promise.resolve(true);
                    });
                }
            }
        } catch (e) {
            trace.warn(e.message || 'enableDisableMeetingTypeAction failed');
            enableDisableMeetingTypeAction(meetingTypeId, !shouldBeEnabled);
            setIsPerformingServiceUpdate(false);
            return Promise.reject(e);
        }
    }
    return Promise.resolve(false);
}
